import { render, staticRenderFns } from "./global-radio-group.vue?vue&type=template&id=64771c61"
import script from "./global-radio-group.vue?vue&type=script&lang=js"
export * from "./global-radio-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports